import { EmptyState } from ".";
import { EventStatus } from "../../redux/features/event/event.types";

export const EmptyEventState = ({
  eventStatus = "upcoming",
}: {
  eventStatus?: EventStatus;
}) => {
  return (
    <EmptyState
      text={`No ${eventStatus === "completed" ? "Past" : eventStatus} Events`}
      subtext={`All your ${eventStatus} events would show here`}
      textClassName="!normal-case !font-normal !max-w-[300px]"
      subtextClassName="!max-w-[300px] !text-sm"
      image="/assets/images/calendar-3d.png"
    />
  );
};
